export default __webpack_public_path__ + "assets/plantillamilitar.dfe33fad.xlsx";